module.exports = __webpack_public_path__ + "static/hyperarvin-complete-97c56ffbe76e0a5163a9ccb904c0a26f.jpg";